export default __webpack_public_path__ + "static/media/6.6.fee36f4f.jpg";